<template>
  <div class="d-flex align-center pa-2">
    <!--SELECT SMTP VENDOR-->
    <v-select
      v-model.sync="modelEmailProtocol"
      :items="computedVendors"
      :disabled="!isSettingsEnabled"
      label="Email Protocol"
      item-text="name"
      class="mx-2 mw-160"
      dense
      hide-details
    >
    </v-select>

    <!--SENDER NAME TO SMTP-->
    <v-text-field
      v-model.sync="modelNameSmtp"
      :disabled="!isSettingsEnabled"
      class="mx-2 mb-4 mw-200"
      label="Sender Name to Display"
      :class="[actionType === 'add' && 'required-field']"
      hide-details
    >
    </v-text-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InputsSenderVendor',
  props: {
    organization: Object,
    isSettingsEnabled: Boolean,
    backupType: Number,
    actionType: String,
    isGlobalSettings: Boolean,
  },
  watch: {
    'organization.name': {
      handler: function (n) {
        if (
          this.actionType === 'add' &&
          n !== undefined &&
          !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(n)
        ) {
          this.organization.emailDefinitions.displaySenderName = n
          this.organization.backupEmailDefinitions.displaySenderName = n
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters(['loggedUser']),
    modelEmailProtocol: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.emailProtocol
          case 1:
            return this.organization.backupEmailDefinitions.emailProtocol
          case 2:
            return this.organization.secondBackupEmailDefinitions.emailProtocol
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.emailProtocol = n)
          case 1:
            return (this.organization.backupEmailDefinitions.emailProtocol = n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.emailProtocol = n)
        }
      },
    },

    modelNameSmtp: {
      get() {
        switch(this.backupType) {
          case 0:
            return this.organization.emailDefinitions.displaySenderName
          case 1:
            return this.organization.backupEmailDefinitions.displaySenderName
          case 2:
            return this.organization.secondBackupEmailDefinitions.displaySenderName
        }
      },
      set(n) {
        switch(this.backupType) {
          case 0:
            return (this.organization.emailDefinitions.displaySenderName = n)
          case 1:
            return (this.organization.backupEmailDefinitions.displaySenderName = n)
          case 2:
            return (this.organization.secondBackupEmailDefinitions.displaySenderName = n)
        }
      },
    },

    computedVendors() {
      if (this.loggedUser.role === 'SuperAdmin' && this.isGlobalSettings)
        return ['SMTP', 'Microsoft Graph']
      return ['Default', 'SMTP', 'Microsoft Graph']
    },
  },
}
</script>
